import { Avatar } from "@mui/material";
import moment from "moment";
import React from "react";
import { api } from "../../../../api/api";
import { StandadCard } from "../../../../components/Cards";
import { CustomDatePicker } from "../../../../components/formsComponents/CustomPicker";
import { DateFilterDropdown } from "../../../../components/Table/components/DateFilterDropdown/DateFilterDropdown";
import { DataTable } from "../../../../components/Table/DataTable";
import { useDateFilter } from "../../../../components/Table/hooks/useDateFilter";
import {
  IDataTableProps,
  MobileLogoRenderType,
  RenderType,
} from "../../../../components/Table/interfaces/IDataTableProps";
import {
  CSVExportPlugin,
  RefreshPlugin,
} from "../../../../components/Table/plugins";
import { IComplaint } from "../../../../constants/commonTypes";
import { useAuth } from "../../../../contexts/AuthProvider/AuthProvider";
import { useMessagesPopup } from "../../../../contexts/MessagesPopupProvider/MessagesPopupProvider";
import { IComplaintDetails } from "../../interface/IComplaint";
import { convertToIST } from "../../../../helpers";

export const ComplaintReport = ({
  membershipId,
}: {
  membershipId?: string;
}) => {
  const [tablePagination, setTablePagination] = React.useState({
    pageNumber: 1,
    rowsInPerPage: 10,
  });
  const [totalRecords, setTotalRecords] = React.useState(0);
  const { showTopErrorSnackbar } = useMessagesPopup();
  const [Loading, setLoading] = React.useState(false);
  const [complaintDetails, setComplaintDetails] = React.useState<
    IComplaintDetails[]
  >([]);
  const {
    date,
    type,
    handleDateSelectChange,
    dateDropdownList,
    setDate,
    setType,
  } = useDateFilter();
  const auth = useAuth();
  const fetchMembershipDetails = async () => {
    if (auth.user.isLogin && auth.user.tokens && membershipId) {
      try {
        setLoading(true);

        const res = await api.get(
          `open-and-closed-complaint-list?page=${tablePagination.pageNumber}&size=${tablePagination.rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}&membership_code=${membershipId}`,
          {
            headers: {
              "auth-Token": auth.user.tokens.access,
            },
          }
        );
        setComplaintDetails(res.data.result);
        setTotalRecords(res.data.total.totalDataLength);

        console.log(res);
      } catch (err) {
        showTopErrorSnackbar("Something went wrong!!");
      } finally {
        setLoading(false);
      }
    }
  };


  



  React.useEffect(() => {
    fetchMembershipDetails();
  }, [membershipId, date, tablePagination]);

  // ===========table data====================
  const ComplaintDetails: IDataTableProps = {
    isPagination: true,
    isDataLoading: Loading,
    totalRecords: totalRecords,
    rowsPerPageOptions: tablePagination.rowsInPerPage,
    tableCommandBarProps: {
      leftItems: {
        customPlugins: [
          {
            key: "byDate",

            onRender: () => (
              <DateFilterDropdown
                value={type}
                options={dateDropdownList}
                onChange={handleDateSelectChange}
              />
            ),
          },
          {
            key: "fromDate",
            onRender: () =>
              type === "custom" ? (
                <CustomDatePicker
                  sx={{ minWidth: "142px" }}
                  value={date.fromDate}
                  onChange={(newValue) => {
                    const newDate = moment(newValue).format("YYYY-MM-DD");
                    setDate({ ...date, fromDate: newDate });
                  }}
                />
              ) : (
                <></>
              ),
          },
          {
            key: "toDate",
            onRender: () =>
              type === "custom" ? (
                <CustomDatePicker
                  sx={{ minWidth: "142px" }}
                  value={date.toDate}
                  onChange={(newValue) => {
                    const newDate = moment(newValue).format("YYYY-MM-DD");
                    setDate({ ...date, toDate: newDate });
                  }}
                />
              ) : (
                <></>
              ),
          },
          {
            key: "refresh",
            onRender: () => <RefreshPlugin onClick={fetchMembershipDetails} />,
          },
          {
            key: "csvExport",
            onRender: (columns, items) => (
              <CSVExportPlugin
                columns={columns}
                items={items}
                filePrefixName="Report"
              />
            ),
          },
        ],
      },
      rightItems: {
        plugins: {
          searchField: {
            searchKeys: ["user_name"],
            items: complaintDetails,
          },
        },
      },
    },
    mobileLogo: {
      type: MobileLogoRenderType.reactNode,
      onMobileLogoRender: (data: any) => {
        return (
          <Avatar
            sx={{
              width: 45,
              height: 45,
              color: "#fff",
              ml: "-8px",
              mr: 2,
            }}
          ></Avatar>
        );
      },
    },
    columns: [
      {
        key: "service_status",
        headerName: "Status",
        fieldName: "service_status",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },
      {
        key: "complaint_no",
        headerName: "Complaint No.",
        fieldName: "complaint_no",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },
      {
        key: "user_name",
        headerName: "Name",
        fieldName: "user_name",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },

      {
        key: "reg_contact_no",
        headerName: "Mobile Number",
        fieldName: "reg_contact_no",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },
      {
        key: "vehicle_number",
        headerName: "Vehicle Number",
        fieldName: "vehicle_number",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },
      {
        key: "vehicle_make",
        headerName: "Brand",
        fieldName: "vehicle_make",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },
      {
        key: "vehicle_model",
        headerName: "Model Name",
        fieldName: "vehicle_model",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },

      {
        key: "service_city",
        headerName: "Service City",
        fieldName: "service_city",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },
      {
        key: "created_dt",
        headerName: "Complaint Date & Time",
        fieldName: "created_dt",
        renderType: RenderType.DATE_TIME,
        exportCellWidth: 35,
        onRowCellRender: (value, row: IComplaint) => (
          <div>
            {/* Adding 5 hours and 30 minutes to complaint created time */}
            {convertToIST(row.created_dt)}
          </div>
        ),
      },
      {
        key: "fault_type",
        headerName: "Fault Type",
        fieldName: "fault_type",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },
      {
        key: "fault",
        headerName: "Fault ",
        fieldName: "fault",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },
      {
        key: "sub_fault",
        headerName: "Sub Fault",
        fieldName: "sub_fault",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },
    ],
    items: complaintDetails,
    onPageChange: (newPageNumber: number) => {
      setTablePagination({ ...tablePagination, pageNumber: newPageNumber });
    },
    onRowsPerPageChange: (pageNumber: number, rowsPerPage: number) => {
      setTablePagination({
        pageNumber: pageNumber,
        rowsInPerPage: rowsPerPage,
      });
    },
  };

  return (
    <div>
      <StandadCard heading="Previous Complaint Details" sx={{ mt: 4 }}>
        <DataTable {...ComplaintDetails} />
      </StandadCard>
    </div>
  );
};
